import { unpackError } from "@dashboard/devices/api/helpers";

import HttpService from "./httpService";
import RouteService from "./routeService";

export const getCertificate = async () => {
    try {
        const endpoint = (await RouteService.getSettingsRoute()) + "certificates/all";
        const { data } = await HttpService.get<API.Certificate>(endpoint);
        return data;
    } catch (error) {
        throw unpackError(error);
    }
};

export const updateCertificate = async (certificateString: string) => {
    try {
        const endpoint = (await RouteService.getSettingsRoute()) + "certificates";
        await HttpService.put<{ certificateString: string }>(endpoint, { certificateString });
    } catch (error) {
        throw unpackError(error);
    }
};
